"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = void 0;
var React = require("react");
var PropTypes = require("prop-types");
var bernie_logger_1 = require("bernie-logger");
/**
 * Decorator that injects `logger` as a prop to the decorated
 * component.
 *
 * @param name The name or identifier to associate with the
 * injected logger.
 */
var logger = function (name) { return function (componentClass) {
    var Wrapper = function (props, context) {
        var factory = context.factory || (function () { return bernie_logger_1.NOOP_LOGGER; });
        var log = bernie_logger_1.NOOP_LOGGER;
        try {
            log = factory(name);
        }
        catch (e) {
            //
        }
        return React.createElement(componentClass, __assign(__assign({}, props), { logger: log }));
    };
    Wrapper.contextTypes = {
        factory: PropTypes.func
    };
    Wrapper['wrappedComponent'] = componentClass;
    return Wrapper;
}; };
exports.logger = logger;
//# sourceMappingURL=logger.js.map